"use client";

import { useCallback, useState } from "react";
import { Search, SearchResult, getFacetSearchResults } from "../search";

export function useFilterFacet({ search }: { search: Search }) {
  const [state, setState] = useState<{
    filteredFacets: SearchResult["facets"];
  }>({
    filteredFacets: {},
  });

  const filterFacet = useCallback(
    async (attribute: string, query: string) => {
      if (!query) {
        setState((prev) => {
          const filteredFacets = { ...prev.filteredFacets };
          delete filteredFacets[attribute];
          return {
            ...prev,
            filteredFacets: filteredFacets,
          };
        });
        return;
      }

      const facetSearch = await getFacetSearchResults({
        ...search,
        facetName: attribute,
        facetQuery: query,
      });
      setState((prev) => ({
        ...prev,
        filteredFacets: {
          ...prev.filteredFacets,
          [attribute]: facetSearch,
        },
      }));
    },
    [search],
  );

  return {
    filterFacet,
    filteredFacets: state.filteredFacets,
  };
}
